module.exports = __webpack_public_path__ + "static/media/memento10k.8964d2d1.png";